import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SearchUsers } from "@/components/SearchUsers";

export const ProfileHeader = ({ onSignOut }: { onSignOut: () => Promise<void> }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center space-x-4">
          <div className="flex items-center">
            <img 
              src="/lovable-uploads/d552ed3f-b5c5-4bef-b2b2-d29fbfb5238b.png" 
              alt="Scheduler Logo" 
              className="h-[3.6rem] w-auto cursor-pointer"
              onClick={() => navigate("/")}
            />
          </div>
          <SearchUsers />
        </div>
        <Button variant="ghost" size="icon" onClick={onSignOut}>
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
};